import { useEffect, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { setBasketFromServer } from '../../../store/slices/basketSlice';
import { getStoredBasket } from '../libs/basketStorage';

export const useGetBasket = () => {
  const dispatch = useDispatch();

  const initData = useMemo(() => ({ basket: getStoredBasket() }), []);
  const { data = initData, isLoading } = useQuery({
    // Deliberately not keyed on the branch. Storage holds one basket for the
    // whole app (BASKET_STORAGE_KEY), and `queryFn` ignores the branch anyway,
    // so a branch in the key buys nothing — it only makes changing the address
    // switch to a fresh cache entry, which falls back to `initialData`: the
    // basket as it was at startup. That silently wiped everything added since.
    // Re-syncing the basket against the new branch is a separate concern and
    // already happens in useGetNearesBranch.
    queryKey: ['basket'],
    queryFn: async () => ({
      basket: getStoredBasket(),
    }),
    enabled: true,
    initialData: initData,
    staleTime: Infinity,
  });

  useEffect(() => {
    dispatch(setBasketFromServer(data?.basket || []));
  }, [data, dispatch]);

  return {
    ...data,
    isLoading,
  };
};
